export const playerHandoff = {
    deviceAlreadyPlaying: false,
    deviceCurrentUri: '',
    deviceWasPaused: false,
    pendingDlnaSeek: -1,
    pendingLocalSeek: -1,
};
